import { motion } from 'framer-motion';
import styled from 'styled-components';
import { colors } from '../../utils/colors';

const TitleWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['centered', 'spacing', 'maxWidth'].includes(prop)
})`
  text-align: ${props => props.centered ? 'center' : 'left'};
  margin-bottom: ${props => props.spacing || '3rem'};
  max-width: ${props => props.maxWidth || 'none'};
  margin-left: ${props => props.centered ? 'auto' : '0'};
  margin-right: ${props => props.centered ? 'auto' : '0'};
`;

const MainTitle = styled(motion.h2).withConfig({
  shouldForwardProp: (prop) => !['size'].includes(prop)
})`
  font-size: ${props => props.size || '2.5rem'};
  color: ${colors.textDark};
  margin-bottom: 1rem;
  font-weight: 600;
`;

const Subtitle = styled(motion.p).withConfig({
  shouldForwardProp: (prop) => !['spacing'].includes(prop)
})`
  font-size: 1.1rem;
  color: ${colors.textLight};
  line-height: 1.6;
  margin-top: ${props => props.spacing || '0.5rem'};
`;

const Highlight = styled.span`
  color: ${colors.primary};
`;

export const SectionTitle = ({
  title,
  subtitle,
  centered = true,
  highlightWords = [],
  spacing,
  maxWidth = '600px',
  size
}) => {
  const highlightText = (text) => {
    if (!highlightWords.length) return text;
    
    const regex = new RegExp(`(${highlightWords.join('|')})`, 'gi');
    return text.split(regex).map((part, i) => 
      highlightWords.includes(part) ? <Highlight key={i}>{part}</Highlight> : part
    );
  };

  return (
    <TitleWrapper centered={centered} spacing={spacing} maxWidth={maxWidth}>
      <MainTitle
        size={size}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {highlightText(title)}
      </MainTitle>
      {subtitle && (
        <Subtitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {highlightText(subtitle)}
        </Subtitle>
      )}
    </TitleWrapper>
  );
};
